import { inject, InjectionToken } from '@angular/core';
import { uploadDocumentSignalStore } from '../store';
import { UploadDocumentSignalState } from '../types';

export const UPLOAD_DOCUMENT_TOKEN =
  new InjectionToken<UploadDocumentSignalState>('Upload Documen Token');

export const UPLOAD_DOCUMENT_PROVIDER = {
  provide: UPLOAD_DOCUMENT_TOKEN,
  useClass: uploadDocumentSignalStore,
};

export function uploadDocumentTokenizer() {
  return inject(UPLOAD_DOCUMENT_TOKEN);
}
